import React, { useState, useEffect } from 'react'

import { Radio, RadioGroup } from '@wartek-id/radio'
import { Button } from '@wartek-id/button'

import { ResponsiveSheet } from 'components/ResponsiveLayout'

type TopicFilterProps = {
  isOpen: boolean
  selected: string
  onClose: () => void
  onSelect: (value: string) => void
  isDesktop?: boolean
}

const STATE_FILTER = {
  recommendation: 'Rekomendasi',
  newest: 'Paling baru',
  oldest: 'Paling lama',
  'almost-done': 'Hampir selesai',
  'just-started': 'Baru mulai',
  title: 'Judul A-Z',
}

const TopicFilter = ({
  isOpen,
  selected,
  onClose,
  onSelect,
  isDesktop = false,
}: TopicFilterProps) => {
  const [localSelected, setLocalSelected] = useState(selected)

  useEffect(() => {
    if (isOpen) {
      setLocalSelected(selected)
    }
  }, [isOpen, selected])

  const handleSelect = (value: string) => {
    setLocalSelected(value)
    if (!isDesktop) {
      onSelect(value)
    }
  }

  const handleSave = () => {
    onSelect(localSelected)
  }

  return (
    <ResponsiveSheet
      isDesktop={isDesktop}
      isOpen={isOpen}
      title="Urutkan topik berdasarkan"
      onClose={onClose}
      desktopFooter={
        <div className="flex gap-4 w-full">
          <Button className="!w-full" color="white" onClick={onClose}>
            Kembali
          </Button>
          <Button className="!w-full" color="black" onClick={handleSave}>
            Simpan
          </Button>
        </div>
      }
    >
      <RadioGroup
        name="filter"
        value={localSelected}
        className="flex-col"
        onChange={handleSelect}
      >
        {Object.keys(STATE_FILTER).map((key) => (
          <Radio key={key} value={key} className="mb-2">
            {STATE_FILTER[key as keyof typeof STATE_FILTER]}
          </Radio>
        ))}
      </RadioGroup>
    </ResponsiveSheet>
  )
}

export default TopicFilter
